module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "AddBackCardView2");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AddBackCardView2!./src/pages/Shop/AddBackCard3/index.js
// module id = 877
// module chunks = 438